import React, { useState, useEffect } from 'react';

import './styles.css';


import { Link, useHistory } from 'react-router-dom';
import { FaAngleDown, FaAngleUp, FaPen, FaTrash } from 'react-icons/fa';
import UserPhoto from '../../../../../components/UserPhoto';
import api from '../../../../../services';
import academyServices from '../../../../../services/academy/academyServices';

export default function AcademyAccessCard(props) {
    const history = useHistory();


    return (
        <div className='academy-page-card' id='card-access'>
            <div>
                <h4><b>Clique no botão abaixo para acessar o módulo desta academia</b></h4>
            </div>
            <Link  className='button' to="/academia" >
                Acessar
            </Link >
            {/* <div className='academy-card-profile-options'>
                <div className='academy-card-profile-infos'>
                    <p><b>ID: </b>{props.academyInfos.id}</p>
                    {
                        showMore ?
                            <>
                                {props.academyInfos.telefone ? <p><b>Telefone: </b>{props.academyInfos.telefone}</p> : []}
                                {props.academyInfos.cidade ? <p><b>Cidade: </b>{props.academyInfos.cidade}</p> : []}
                                {props.academyInfos.logradouro ? <p><b>Endereço: </b>{props.academyInfos.logradouro}, {props.academyInfos.numero}</p> : []}
                            </>
                            : []
                    }
                    <button onClick={() => setShowMore(!showMore)}>
                        {showMore ? "Menos informações" : "Mais informações"} {showMore ? <FaAngleUp /> : <FaAngleDown />}
                    </button>
                </div>

                <div className='academy-card-profile-buttons'>
                    <Link className='button' to={`/admin/academias/${props.academyInfos.id}/editar`}>Editar<FaPen /></Link>
                                
                    <button className='button academy-card-delete' onClick={() => deleteAcademy(props.academyInfos.id)}>Excluir <FaTrash/></button>
                </div>


            </div> */}
        </div>
    )
}